import { AbstractControl } from '@angular/forms';
import { CostNodeInput } from '@generated/graphql';

export function hotelBookingCostValidator(control: AbstractControl) {
  const { value } = control;

  if (!value || value.length === 0) {
    return null;
  }

  const hasInvalid = (value as CostNodeInput[]).find((cost) => {
    if (!cost) return null;

    const keys: (keyof CostNodeInput)[] = ['rate', 'perType', 'chargeTypeId'];

    return keys.some((key: keyof CostNodeInput) => !cost[key]);
  });

  if (hasInvalid) {
    return { 'hotel-booking-cost': true };
  }

  return null;
}
